<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="epi_head" id="epi"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><a href="#/text/9780062973368_Contents#repi"><b>Epigraph</b></a></span></p>
<p class="epi_para"><i>If there is no struggle, there is no progress.</i></p>
<p class="epi_rt">—FREDERICK DOUGLASS,</p>
<p class="epi_rt_1">WEST INDIA EMANCIPATION SPEECH, 1857</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062973368_Epigraph.vue?626bdce6